export default {"src":"/_next/static/media/New York.ceadb7a9.svg","height":458,"width":800,"blurWidth":0,"blurHeight":0};